import { render, staticRenderFns } from "./dhOrder.vue?vue&type=template&id=fef87afc&scoped=true"
import script from "./dhOrder.vue?vue&type=script&lang=js"
export * from "./dhOrder.vue?vue&type=script&lang=js"
import style0 from "./dhOrder.vue?vue&type=style&index=0&id=fef87afc&prod&lang=scss&scoped=true"
import style1 from "./dhOrder.vue?vue&type=style&index=1&id=fef87afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef87afc",
  null
  
)

export default component.exports